var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vertical-pb -helper--flex column space-between" },
    [
      _c("div", { staticClass: "routes-wrapper -helper--flex column" }, [
        _vm.shouldShowRoutes && !_vm.isMultiBusinessFlow
          ? _c(
              "div",
              { staticClass: "route-item -helper--flex align-center" },
              [
                _c(
                  "div",
                  {
                    staticClass: "circle",
                    class:
                      _vm.activeRoute == "partner-personal-details"
                        ? "active"
                        : ""
                  },
                  [_vm._v("1")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "route-indication",
                    class:
                      _vm.activeRoute == "partner-personal-details"
                        ? "lili-color"
                        : ""
                  },
                  [_vm._v("Personal Details")]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldShowRoutes
          ? _c(
              "div",
              { staticClass: "route-item -helper--flex align-center" },
              [
                _c(
                  "div",
                  {
                    staticClass: "circle",
                    class:
                      _vm.activeRoute == "partner-business" ||
                      _vm.activeRoute == "addOwner"
                        ? "active"
                        : ""
                  },
                  [_vm._v(_vm._s(_vm.isMultiBusinessFlow ? "1" : "2"))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "route-indication",
                    class:
                      _vm.activeRoute == "partner-business" ||
                      _vm.activeRoute == "addOwner"
                        ? "lili-color"
                        : ""
                  },
                  [_vm._v("Business Details")]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldShowRoutes
          ? _c(
              "div",
              { staticClass: "route-item -helper--flex align-center" },
              [
                _c(
                  "div",
                  {
                    staticClass: "circle",
                    class: _vm.activeRoute == "plan" ? "active" : ""
                  },
                  [_vm._v(_vm._s(_vm.isMultiBusinessFlow ? "2" : "3"))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "route-indication",
                    class: _vm.activeRoute == "plan" ? "lili-color" : ""
                  },
                  [_vm._v("Choose a Plan")]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldShowRoutes
          ? _c(
              "div",
              { staticClass: "route-item -helper--flex align-center" },
              [
                _c(
                  "div",
                  {
                    staticClass: "circle",
                    class:
                      _vm.activeRoute == "review" ||
                      _vm.activeRoute == "kybPending"
                        ? "active"
                        : ""
                  },
                  [_vm._v(_vm._s(_vm.isMultiBusinessFlow ? "3" : "4"))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "route-indication",
                    class:
                      _vm.activeRoute == "review" ||
                      _vm.activeRoute == "kybPending"
                        ? "lili-color"
                        : ""
                  },
                  [_vm._v("Confirmation")]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer" }, [
      _c("span", { staticClass: "main-logo-dark-blue" }),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [_vm._v("Lili Customer Service")]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            { attrs: { href: "mailto:support@lili.co", target: "_blank" } },
            [_vm._v("Email our support team")]
          ),
          _vm._v(" or call us")
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("(855) 545-4380")]),
        _vm._v(" "),
        _c("div", [_vm._v("9:00am-7:00pm EST Monday - Friday")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "separator" }),
      _vm._v(" "),
      _c("div", { staticClass: "disclaimer" }, [
        _vm._v(
          "\n      Lili is a financial technology company, not a bank.\n      Banking services provided by Sunrise Banks, N.A., Member FDIC.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bbd8f3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bbd8f3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalUiComponents/VerticalProgressBar.vue
// module id = null
// module chunks = 